import { CheckboxContainer } from '@anm/components/form/Checkbox';
import styled from 'styled-components';

export const CheckBoxWrapper = styled.label<{ checked: boolean }>`
  display: inline-flex;
  border-radius: 5px;
  position: relative;
  cursor: pointer;
  flex-grow: 1;
  transition: 0.2s;

  img {
    margin: 0;
  }

  span {
    padding-left: 10px;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 0.01em;
    color: #292a2b;
    user-select: none;
    white-space: nowrap;
  }

  ${CheckboxContainer} {
    margin-top: 0;
  }
`;
